import { styled } from 'mz-ui-kit'

export const Container = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '20px',
})

export const Title = styled('span', ({ $palette }) => ({
  fontSize: '24px',
  fontWeight: '700',
  color: `${$palette('TEXT')}`,
}))
